const en = {
  // Common Labels
  fullname: "Full Name",
  firstName: "First Name",
  middleName: "Middle Name",
  lastName: "Last Name",
  emailAddress: "Email Address",
  dateOfBirth: "Date Of Birth",
  phoneNumber: "Phone Number",
  mobileNumber: "Mobile Number",
  panNumber: "PAN Number",
  profilePhoto: "Profile Photo",
  searchName: "Search Name",

  // Event
  category: "Category",
  school: "School",
  fromDate: "From Date",
  toDate: "To Date",
  fromTime: "From Time",
  toTime: "To Time",
  venue: "Venue",
  description: "Description",
  eventPlaceholder: "Select Event section",
  venuePlaceholder: "Enter venue",
  descriptionPlaceholder: "Enter description",
  shortDescriptionPlaceholder: "Enter short description",
  schoolPlaceholder: "Enter School",
  // Profile Menus
  changePassword: "Change Password",
  contentManagement: "Content Management",
  profile: "Profile",
  logout: "Logout",
  lastLogin: "Last Login",

  // Content Management
  hallOfFame: "Hall of Fame",
  managementTalk: "Management Talk",
  newsAndBlogs: "News and Blogs",
  announcements: "Announcements",
  opinionPoll: "Opinion Poll",
  subject: "Subject",
  famePhoto: "Fame Photo",
  content: "Content",
  enter: "Enter",
  designation: "Designation",
  readMoreLink: "Read More Link",
  topicName: "Topic Name",

  // Table
  image: "Image",
  select: "Select",
  rowsPerPage: "Rows per page",
  noOfSection: "No. of Sections",

  // Dashboard Menus
  dashboard: "Dashboard",
  admission: "Admission",
  birthday: "Birthday",
  workAnniversary: "Work Anniversary",
  capturePayment: "Capture Payment",
  admissionCycleConfig: "Admission Cycle Config",
  admissionSeatAllocationConfig: "Admission Seat Allocation Config",
  admissionApplicationList: "Admission Application List",
  captureInterviewDetails: "Capture Interview Details",
  annualAcademicTransition: "Annual Academic Transition",
  report: "Report",
  studentReport: "Student Report",
  attendanceReport: "Attendance Report",
  timeTable: "Time-Table",
  shift: "Shift",
  dayScheduleList: "Day Schedule List",
  timeTableView: "Time Table View",
  messaging: "Messaging",
  messagingSms: "Create Message",
  messagingEmail: "Manage Message",
  events: "Events",
  createEvent: "Create Event",
  eventCalendar: "Event Calendar",
  master: "Master",
  academicConfiguration: "Academic Configuration",
  isActiveRequired: "Status is required",
  staff: "Staff",
  holiday: "Holiday",
  bulkUpload: "Bulk Upload",
  syllabus: "Syllabus",
  receiver: "Receiver",
  botAttendance: "Bot Attendance",
  exam: "Exam",
  examConfiguration: "Exam Configuration",
  examRules: "Exam Rules",
  examRule: "Exam Rules",
  examSchedule: "Exam Schedule",
  examTimeTable: "Exam Time Table",
  examResult: "Exam Result",
  download: "Download",
  applicationDetails: "Application Details",
  attendanceDashboard: "Attendance Dashboard",
  admissionConfig: "admission-config",

  // PASSWORD
  oldPassword: "Old Password",
  newPassword: "New Password",
  retypeNewPassword: "Confirm New Password",
  oldPasswordPlaceholder: "Enter old password",
  newPasswordPlaceholder: "Enter new password",
  confirmPasswordPlaceholder: "Enter confirm password",

  // Profile Setup
  profileSetup: "Profile Setup",
  changeLanguage: "Change Language",
  selectLanguage: "Select Language",
  maritalStatus: "Marital Status",
  selectMaritalStatus: "Select Marital Status",
  single: "Single",
  married: "Married",
  spouseName: "Spouse Name",
  spouseNamePlaceholder: "E.g. Spouse Name",
  male: "Male",
  female: "Female",
  other: "Other",
  retry: "Retry",
  fatherName: "Father Name",
  fatherNamePlaceholder: "E.g. Father Name",
  motherName: "Mother Name",
  motherNamePlaceholder: "E.g. Mother Name",
  aadhaarNumber: "Aadhar Number",
  updatePassword: "Update Password",

  //Admission Schedule:
  admissionInterviewSchedule: "Admission Interview Schedule",
  inviteStatus: "Invite Status",
  name: "Name",
  interviewSchedule: "Interview Schedule",
  selectAdmissionType: "Select admission type",
  seatAllocationApplication: "Seat Allocated Application List",
  applicationId: "Application ID",
  appliedDate: "Applied Date",
  annualTransitionStatus: "Annual Transition Status",
  TransitionCompleted: "Transition Completed",
  TransitionNotCompleted: "Transition Not Completed",
  backAdmissionApplicationList: "Back to Admission Application List",
  totalPromoted: "Total Promoted",
  totalDetained: "Total Detained",
  publishAnnualTransition: "Publish Annual Transition",
  updatePromotionStatus: "Update Promotion Status",
  passFail: "Pass/Fail",
  assignSection: "Assign Section",
  interviewInviteSentSuccess: "Interview invite sent successfully!",
  interviewSaveFailed: "Failed to save interview schedule.",
  nameRequired: "Name is required",
  dateRequired: "Date is required",
  dateMustBeTodayOrFuture: "Date must be today or a future date",
  fromTimeRequired: "From Time is required",
  toTimeRequired: "To Time is required",
  toTimeMustBeAfterFromTime: "To Time must be after From Time",
  venueRequired: "Venue is required",
  selectAtLeastOneStudent:
    "Please select at least one student from the Seat Allocated Application List",
  interviewCreateSuccess: "Interview schedule created successfully!",
  interviewUpdateSuccess: "Interview schedule updated successfully!",

  fileName: "File Name",
  sizeKb: "Size(kb)",
  lastModified: "Last Modified",
  uploadNewOfflineApplicationFile: "upload New Offline Application File",
  // Profile Validation
  firstNameRequired: "First name is required",
  lastNameRequired: "Last name is required",
  fatherNameRequired: "Father name is required",
  mobileNumberRequired: "Mobile number is required",
  mobileNumberInvalid: "Enter valid 10-digit mobile number",
  bloodGroupRequired: "Blood group is required",
  genderRequired: "Gender is required",
  aadharNumberInvalid: "Enter valid 12-digit Aadhar number",
  dateOfBirthRequired: "Date of birth is required",
  pincodeRequired: "Pincode is required",
  pincodeInvalid: "Enter valid 6-digit pincode",
  addressRequired: "Address is required",
  cityRequired: "City is required",
  stateRequired: "State is required",
  countryRequired: "Country is required",
  languageRequired: "Language is required",
  incomeRequired: "Income is required",
  maritalStatusRequired: "Marital status is required",
  anniversaryRequired: "Anniversary is required",
  spouseNameRequired: "Spouse name is required",
  profileUpdateSuccess: "Profile updated successfully!",
  profileUpdateFailed: "Failed to update profile. Please try again.",

  // Also add these keys for CreateMessage validation (if not already added)
  staffTypeRequired: "Staff Type is required",
  studentRequired: "Student is required",
  teacherRequired: "Teacher is required",

  // Create message
  staffType: "Staff type",
  allClass: "All Class",
  allSection: "All Section",
  allStudents: "All Students",
  message: "Message",
  attachment: "Attachment",
  role: "Role",
  send: "SEND",
  selectSchoolPlaceholder: "Select school",
  messagePlaceholder: "Enter message",
  inbox: "INBOX",
  sentItems: "SENT ITEMS",
  noSentMessagesFound: "No sent messages found",
  noMessagesFound: "No messages found",
  selectMessageToViewDetails: "Select a message to view details",
  allSchool: "All School",
  allMembers: "All Members",
  staffAccount: "Staff Account",
  studentAccount: "Student Account",
  parentAccount: "Parent Account",
  schoolCockpit: "School Cockpit",
  allStaff: "All Staff",
  teaching: "Teaching",
  administrative: "Administrative",
  management: "Management",
  noFileChosen: "No file chosen",
  chooseFile: "Choose File",
  onlyImageFilesAllowed: "Only jpg, jpeg, png, gif files are allowed",
  fileUploadFailed: "Failed to upload file. Please try again.",
  schoolRequired: "School is required",
  roleRequired: "Role is required",
  subjectRequired: "Subject is required",
  messageRequired: "Message is required",
  messageSentSuccess: "Message sent successfully",

  // Subject List
  subjectList: "Subject List",
  subjectName: "Subject Name",
  actions: "Actions",

  // Group List
  groupName: "Group Name",
  serialNo: "S.No",
  groupList: "Group List",

  // Academic List
  startYear: "Start Year",
  endYear: "End Year",
  academicYear: "Academic Year",
  selectAcademicYear: "Select Academic Year",
  isUpcomingYear: "Is This Upcoming Year?",
  yes: "Yes",
  no: "No",
  selectDate: "Select Date",
  startYearPlaceholder: "E.g. 2025",
  endYearPlaceholder: "E.g. 2026",
  startYearRequired: "Start Year is required",
  startYearInvalid: "Please enter a valid year (e.g., 2025)",
  endYearRequired: "End Year is required",
  endYearInvalid: "Please enter a valid year (e.g., 2026)",
  endYearGreater: "End Year must be greater than Start Year",
  fromDateRequired: "From Date is required",
  fromDateYearMismatch: "From Date must match the Start Year",
  toDateRequired: "To Date is required",
  toDateYearMismatch: "To Date must match the End Year",
  toDateAfter: "To Date must be after From Date",
  isUpcomingYearRequired: "Is This Upcoming Year is required",
  academicCreatedSuccess: "Academic configuration created successfully!",
  academicUpdatedSuccess: "Academic configuration updated successfully!",
  academicSaveFailed:
    "Failed to save academic configuration. Please try again.",
  somethingWrong: "Something went wrong!",
  success: "Success",
  failed: "Failed",
  loading: "Loading...",
  cancel: "CANCEL",
  submit: "SUBMIT",
  update: "UPDATE",
  submitting: "Submitting...",
  updating: "Updating...",

  // Upload
  uploadYourFile: "Upload your file here",
  downloadSampleFile: "DOWNLOAD THE SAMPLE FILE",
  empId: "Emp ID",
  email: "Email",
  mobileNo: "Mobile No",
  courses: "Courses",
  import: "IMPORT",

  // Student List
  studentName: "Student Name",
  studentId: "Student id",
  status: "Status",

  // Holiday List
  holidayType: "Holiday Type",
  noOfDays: "No. of Days",

  // Shift
  noOfBreak: "No. of Breaks",
  noOfPeriods: "No. of Periods",
  shiftConfigurationList: "Shift Configure List",

  // Create syllabus
  pageFrom: "Page From",
  pageTo: "Page To",
  examTypePlaceholde: "Select Exam Type",
  subjectPlaceholder: "Select subject",
  grouPlaceholder: "Select group name",
  // Day Schedule List
  dayScheduleListTitle: "Day Schedule List",
  classLabel: "Class",
  sectionLabel: "Section",
  shiftLabel: "Shift",
  classPlaceholder: "Select Class",
  sectionPlaceholder: "Select Section",
  shiftPlaceholder: "Select Shift",
  selectsubjectPlaceholder: "Select subject",
  unit: "Units",
  chapter: "Chapter",
  shortDescription: "Short Description",
  noOfMale: "No. of Male",
  noOfFemale: "No. of Female",
  totalNoOfStudent: "Total No. of Students",
  // Table
  dayPeriodHeader: "Day / Period",
  actionHeader: "Action",
  viewAction: "View",
  shift1: "SHIFT 1",
  shift2: "SHIFT 2",

  // Create Schedule List
  viewDayScheduleTitle: "Create Day Schedule",
  editDayScheduleTitle: "Edit Day Schedule",
  confirmDeleteSchedule: "Are you sure you want to delete this schedule?",
  confirmDeleteTimeTable: "Are you sure you want to delete this timetable?",
  selectAllStudentsToVerify: "Please select all students to verify.",
  noExamResultFound: "There is no Exam Result for this class.",
  class: "Class",
  section: "Section",
  day: "Day",
  period: "Period",
  periodSubject: "Period Subject",
  periodSubjectPlaceholder: "Period Subject",

  // Button Labels
  all: "All",
  add: "ADD",
  edit: "EDIT",
  back: "BACK",
  adding: "Adding...",
  delete: "DELETE",
  view: "VIEW",
  save: "SAVE",
  cancel: "CANCEL",
  deleting: "Deleting...",
  loading: "Loading...",
  updating: "Updating...",
  updateButton: "Update",
  saving: "Saving...",
  submitting: "Submitting...",
  createButton: "Create",
  cancelButton: "Cancel",
  saveButton: "Save",
  searchButton: "Search",
  resetButton: "Reset",
  checkExamButton: "Check Exam",
  refreshButton: "Refresh",
  addSyllabus: "ADD SYLLABUS",
  date: "Date",
  teacher: "Teacher",
  total: "Total",
  time: "Time",
  clear: "Clear",
  action: "Action",

  // ==================== MONTHS ====================
  totalStudents: "Total Students",
  batch: "Batch",
  month: "Month",
  selectMonth: "Select Month",
  present: "Present",
  absent: "Absent",
  leave: "Leave",
  workingDays: "Working Days",
  downloadExcel: "DOWNLOAD EXCEL",
  january: "January",
  february: "February",
  march: "March",
  april: "April",
  may: "May",
  june: "June",
  july: "July",
  august: "August",
  september: "September",
  october: "October",
  november: "November",
  december: "December",

  // PROFILE
  personalInfo: "Personal Information",
  locationBackground: "Location & Background",
  spiritualIdentification: "Spiritual & Identification",
  editProfile: "Edit Profile",
  backToProfile: "Back to Profile",
  saveProfile: "Save Profile",
  optional: "(Optional)",

  // ADDRESS
  location: "Location",
  address: "Address",
  district: "District",
  geographicCoordinates: "Geographic Coordinates",
  cityTownVillage: "City / Town / Village",

  // STUDENT SETUP
  student: "Student",
  fatherInformation: "Father Information",
  motherInformation: "Mother Information",
  guardianInformation: "Guardian Information",
  emergencyContactNumber1: "Emergency Contact Number 1",
  emergencyContactNumber2: "Emergency Contact Number 2",
  familyDoctor: "Family Doctor",
  rollId: "Roll Id",
  //pan Card
  panNumberInvalid: "Enter valid PAN number (Ex: ABCDE1234F)",
  aadharNumber: "Aadhar Number",
  gender: "Gender",
  religion: "Religion",
  bloodGroup: "Blood Group",
  medicalCondition: "Medical Condition",
  studentPhoto: "Student Photo",
  anniversary: "Anniversary",
  address1: "Address 1",
  address2: "Address 2",
  address3: "Address 3",
  pincode: "Pincode",
  city: "City",
  country: "Country",
  state: "State",
  occupation: "Occupation",
  income: "Income",
  sameAddress: "(Same Address)",
  isChildStayingWithGuardian: "Is the Child Staying with Guardian?",
  yes: "Yes",
  no: "No",
  relationType: "Relation Type",
  hospital: "Hospital",

  // Placeholders
  firstNamePlaceholder: "E.g. First Name",
  middleNamePlaceholder: "E.g. Middle Name",
  lastNamePlaceholder: "E.g. Last Name",
  rollIdPlaceholder: "E.g. 10102004001",
  emailPlaceholder: "E.g. student@gmail.com",
  fatherEmailPlaceholder: "E.g. father@gmail.com",
  motherEmailPlaceholder: "E.g. mother@gmail.com",
  guardianEmailPlaceholder: "E.g. guardian@gmail.com",
  emailAddressPlaceholder: "E.g. Email Address",
  emailAltPlaceholder: "E.g. Email",
  dateOfBirthPlaceholder: "Ex: 30/07/2016",
  aadharNumberPlaceholder: "E.g. Aadhar Number",
  aadharNumberAltPlaceholder: "Ex: 43215678907",
  selectGender: "Select Gender",
  selectClass: "Select Class",
  selectSection: "Select Section",
  selectReligion: "Select Religion",
  selectCategory: "Select Category",
  selectBloodGroup: "Select Blood Group",
  medicalConditionPlaceholder: "E.g. Medical Condition",
  photoPlaceholder: "E.g. Mypic.jpg",
  phoneNumberPlaceholder: "E.g. Phone Number",
  phoneNoPlaceholder: "E.g. Phone No",
  mobileNumberPlaceholder: "E.g. Mobile Number",
  panNumberPlaceholder: "Ex: 678909XYZ",
  addressPlaceholder: "E.g. Address",
  pincodePlaceholder: "E.g. Pincode",
  cityPlaceholder: "E.g. City",
  selectCountry: "Select Country",
  selectState: "Select State",
  selectOccupation: "Select Occupation",
  selectIncome: "Select Income",
  selectRelation: "Select Relation",
  hospitalPlaceholder: "E.g. Hospital",

  // STUDENT LIST
  studentList: "Student List",
  addButton: "ADD",
  downloadButton: "DOWNLOAD",
  searchStudentId: "Search Student ID",
  searchStudentName: "Search Student Name",
  searchEmail: "Search Email",
  searchClass: "Search Class",
  searchSection: "Search Section",
  searchGender: "Search Gender",
  searchBloodGroup: "Search Blood Group",
  noRecordsToDisplay: "No records to display",
  failedToDownload: "Failed to download student list",
  viewStudent: "View Student",

  // ==================== EXAM CONFIGURATION ====================
  examType: "Exam Type",
  examTypeRequired: "Exam Type is required",
  examName: "Exam Name",
  examNamePlaceholder: "E.g. Half Yearly Exam",
  selectExamName: "Select Exam Name",
  allExams: "All Exams",
  startDate: "Start Date",
  endDate: "End Date",
  startDatePlaceholder: "Ex: 30/07/2024",
  endDatePlaceholder: "Ex: 30/08/2024",
  isAnnualExam: "Is This an Annual Exam?",
  active: "Active",
  inactive: "Inactive",
  examConfigEditNote:
    "The exam schedule has already been created. Editing the Status is not allowed.",

  // Exam Configuration Validation
  examNameRequired: "Exam Name is required",
  startDateRequired: "Start Date is required",
  endDateRequired: "End Date is required",
  endDateAfterStart: "End Date must be after Start Date",

  // Exam Configuration Messages
  createSuccess: "Created successfully!",
  updateSuccess: "Updated successfully!",
  deleteSuccess: "Deleted successfully!",
  saveFailed: "Failed to save. Please try again.",
  fetchFailed: "Failed to fetch details. Please try again.",
  deleteFailed: "Failed to delete.",
  confirmDelete: "Are you sure you want to delete?",

  // ==================== EXAM RULES ====================
  examPassRules: "Exam Pass Rules",
  theory: "Theory",
  practical: "Practical",
  passRulesRequired: "At least one pass rule must be selected",
  examRulesNote:
    "Only Students who meet the passing criteria will be eligible for ranking.",

  // ==================== EXAM SCHEDULE ====================
  examMode: "Exam Mode",
  includeSubject: "Include Subject",
  dateOfExam: "Date of Exam",
  passMark: "Pass Mark",
  maximumMark: "Maximum Mark",
  durationHrs: "Duration (hrs)",
  classRequired: "Class is required",
  sectionRequired: "Section is required",
  includeAtLeastOneSubject: "Please include at least one subject",
  fillRequiredSubjectFields:
    "Please fill Date of Exam, From Time, and To Time for all included subjects",
  createExamSchedule: "Create Exam Schedule",
  editExamSchedule: "Edit Exam Schedule",

  // ==================== EXAM SCHEDULE VIEW ====================
  examScheduleList: "Exam Schedule List",
  modeOfExam: "Mode of Exam",
  maxMark: "Max Mark",
  startTime: "Start Time",
  endTime: "End Time",
  duration: "Duration",
  examTimeTableList: "Exam Time Table List",
  selectExamAndClass: "Please select Exam Name to view the timetable",

  // ==================== STAFF & STUDENT & ATTENDANCE BULK UPLOAD ====================
  downloadFrameSet: "DOWNLOAD THE FRAME SET",
  uploadFrameSet: "UPLOAD FRAME SET",
  uploading: "Uploading...",
  selectCategoryFirst: "Please select a category first",
  bulkUploadSuccess: "File uploaded successfully!",
  bulkUploadFailed: "Failed to upload file. Please try again.",
  staffDefectList: "Staff Defect List",
  studentDefectList: "Student Defect List",
  defectList: "Defect List",

  // ==================== MARK BULK UPLOAD ====================
  markBulkUpload: "Mark Bulk Upload",
  uploadMarksheet: "Upload Marksheet",
  selectModeOfExam: "Select Mode",
  modeOfExamRequired: "Mode of Exam is required",
  markBulkUploadSuccess: "Marks uploaded successfully!",
  markBulkUploadFailed: "Failed to upload marks. Please try again.",
  downloadFailed: "Failed to download Excel. Please try again.",
  pleaseSelectExcelFile: "Please select an Excel file to upload.",
  onlyExcelFilesAllowed: "Only Excel files (.xlsx) are allowed",

  // ==================== PUBLISH MARK ====================
  publishMarkList: "Publish Mark List",
  publishMarkView: "Publish Mark View",
  subjects: "Subjects",
  published: "PUBLISHED",
  publish: "PUBLISH",
  publishSuccess: "Result published successfully!",
  publishFailed: "Failed to publish result.",
  studentsPassed: "Students Passed",
  passedPercentage: "Passed Percentage",
  studentsFailed: "Students Failed",
  failedPercentage: "Failed Percentage",
  totalMark: "Total Mark",
  rank: "Rank",
  dates: "Dates",
  votesPolled: "Votes Polled",
  verified: "Verified",
  notVerified: "Not Verified",
  publishView: "Publish View",
  selectAllFilters: "Please select Class, Section and Exam Name",

  // ==================== ATTENDANCE ====================
  attendance: "Attendance",
  attendanceList: "Attendance List",
  studentAttendanceMonthlyView: "Student Attendance Monthly View",
  attendancePercentage: "Attendance(%)",
  selectDate: "Select Date",
  dateRequired: "Date is required",
  createAttendance: "Create Attendance",
  editAttendance: "Edit Attendance",
  noStudentsFound: "No students found",
  attendanceSaveSuccess: "Attendance saved successfully!",
  attendanceUpdateSuccess: "Attendance updated successfully!",
  attendanceSaveFailed: "Failed to save attendance. Please try again.",
  classStrength: "Class Strength",

  // ==================== ATTENDANCE DASHBOARD ====================
  totalWorkingDaysYear: "Total Working Days (Year)",
  totalPresentYear: "Total Present (Year)",
  totalAbsentYear: "Total Absent (Year)",
  attendancePercentageYear: "Attendance Percentage (Year)",
  totalWorkingDaysMonth: "Total Working Days (Month)",
  totalPresentMonth: "Total Present (Month)",
  totalAbsentMonth: "Total Absent (Month)",
  attendancePercentageMonth: "Attendance Percentage (Month)",
  todayDate: "Today Date",
  today: "today",
  calendarMonth: "month",
  calendarWeek: "week",
  calendarDay: "day",

  // ==================== LEAVE ====================
  leaveList: "Leave List",
  leaveCreate: "Apply Leave",
  noOfDaysLeave: "No. of Days",
  reason: "Reason",
  accepted: "ACCEPTED",
  rejected: "REJECTED",
  withdrawn: "WITHDRAWN",
  pending: "PENDING",

  // ==================== LEAVE CREATE ====================
  leaveRequest: "Leave Request",
  child: "Child",
  selectChild: "Select Child",
  childRequired: "Child is required",
  staffLabel: "Staff",
  fromDateRequired: "From Date is required",
  toDateRequired: "To Date is required",
  toDateAfterFrom: "To Date must be after From Date",
  reasonRequired: "Reason is required",
  selectReason: "Select Reason",
  noteLabel: "Note",
  notePlaceholder: "E.g. Enter your messages",
  upload: "UPLOAD",
  sickLeave: "Sick Leave",
  fever: "Fever",
  familyFunction: "Family Function",
  medical: "Medical",
  personal: "Personal",
  others: "Others",
  leaveCreateSuccess: "Leave request created successfully!",
  leaveUpdateSuccess: "Leave updated successfully!",
  leaveSaveFailed: "Failed to save leave request. Please try again.",
  noteRequired: "Note is required",

  // ==================== STAFF LEAVE LIST ====================
  submitted: "SUBMITTED",
  selectStatus: "Select Status",

  // ==================== STAFF LEAVE APPROVAL ====================
  classTeacherRemark: "Class Teacher Remark",
  approve: "Approve",
  reject: "Reject",
  pleaseAttachMedicalCertificate: "Please Attach Medical Certificate",
  messagingLabel: "Messaging",
  remarkRequired:
    "Please select an action (Approve / Reject / Attach Medical Certificate)",
  leaveApprovalSuccess: "Leave status updated successfully!",
  leaveApprovalFailed: "Failed to update leave status. Please try again.",

  // ==================== HOLIDAY ====================
  selectLeaveType: "Select Leave Type",
  enterYourMessages: "E.g. Enter your messages",
  holidayTypeRequired: "Holiday Type is required",
  toDateAfterOrSameAsFrom: "To Date must be after or same as From Date",
  descriptionRequired: "Description is required",
  toDateCannotBeBeforeFrom: "To Date cannot be before From Date",
  toDateResetWarning: "To Date was reset as it was before From Date",
  holidayCreateSuccess: "Holiday created successfully!",
  holidayUpdateSuccess: "Holiday updated successfully!",
  holidaySaveFailed: "Failed to save holiday. Please try again.",
  holidayFetchFailed: "Failed to fetch holiday details. Please try again.",
  searchHolidayType: "Search Holiday Type",

  // ==================== DASHBOARD COMPONENTS (NEW) ====================
  staffDirectory: "Staff Directory",
  staffName: "Staff Name",
  contact: "Contact",
  profileTitle: "Profile",
  studentDetails: "Student Details",
  myChild: "My Child",
  seeAll: "See All",
  source: "Source",
  readFullSpeech: "Read Full Speech",
  birthdayTitle: "Birthday!",
  birthdayDescription:
    "Birthdays are not ordinary days 🎂 🎁 🎊 🎉 Celebrate – That is the day one saw the light & world on their own !! 🎈 👶 Wish your teachers, colleagues & friends on their special day. 🤩",
  workAnniversaryTitle: "Work Anniversary!",
  workAnniversaryDescription:
    'They say "Experience is a great teacher"... 👆 📝 Wish your teachers & staff on their work anniversaries as they too grow wiser with experience... 🧑 🧔 👨‍🦰',
  hallOfFameEmptyMessage:
    "Announce winners and 🏆 celebrate the successes of your 🤓 👨‍🎓 students & teachers here... Recognition act as Energy Boosters 💪 😊",
  managementTalkEmptyMessage:
    "Cascade management's vision and goals 🤩 in this space to enable your institution to achieve goals and reach newer heights 🤞 🧑 👍",
  opinionPollEmptyMessage:
    'As they say "Students are pillars of the nation". Help them to start voicing their opinion 🤓 👆 on myriad of topics through our Poll Corner 🤟 😀',
  newsBlogsEmptyMessage:
    "Actively engage & educate your stakeholders – Students, Parents, Teachers & Staff and promote meaningful discussion on relevant topics ☝️ 🤪",

  // ==================== ATTENDANCE DASHBOARD ====================
  studentAttendanceDashboard: "Student Attendance Dashboard",
  switchToStaffDashboard: "Switch to Staff Dashboard",
  enrolled: "Enrolled",
  error: "Error Loading Data",

  // ==================== STAFF ATTENDANCE DASHBOARD ====================
  switchToStudentDashboard: "Switch to Student Dashboard",
  staffAttendanceDashboard: "Staff Attendance Dashboard",
  attendanceLogs: "Attendance Logs",

  // ==================== ADMISSION ====================
  admissionName: "Admission Name",
  type: "Type",
  admissionType: "Admission Type",
  selectType: "Select Type",
  enterHere: "Enter here..",
  admissionStartDate: "Admission Start Date",
  admissionEndDate: "Admission End Date",
  screeningStartDate: "Screening Start Date",
  screeningEndDate: "Screening End Date",
  interviewStartDate: "Interview Start Date",
  interviewEndDate: "Interview End Date",
  completionDate: "Completion Date",
  admissionTypeRequired: "Admission Type is required",
  admissionNameRequired: "Admission Name is required",
  admissionStartDateRequired: "Admission Start Date is required",
  admissionEndDateRequired: "Admission End Date is required",
  screeningStartDateRequired: "Screening Start Date is required",
  screeningEndDateRequired: "Screening End Date is required",
  interviewStartDateRequired: "Interview Start Date is required",
  interviewEndDateRequired: "Interview End Date is required",
  completionDateRequired: "Completion Date is required",
  medium: "Medium",
  totalCapacity: "Total Capacity",
  seatAllocationConfiguration: "Seat Allocation Configuration",
  searchSeatConfig: "Search ...",
  studentPassed: "Students Passed",
  passesdPercentage: "Passed Percentage",
  failedPercentage: "Failed Percentage",
  studentFailed: "Student Failed",

  // ==================== ADMISSION FORM X ====================
  // Basic Details Section
  basicDetails: "Basic Details",
  studentNameTamil: "Student's Name (Tamil)",
  studentNameEnglish: "Student's Name (English)",
  studentNameTamilPlaceholder: "Enter Student Name in Tamil",
  studentNameEnglishPlaceholder: "Enter Student Name in English",
  dobInWords: "DOB in Words",
  dobInWordsPlaceholder: "E.g. Twenty-Sixth December...",
  studentNameTamilRequired: "Student's Name (Tamil) is required",
  studentNameEnglishRequired: "Student's Name (English) is required",
  dobInWordsRequired: "DOB in Words is required",
  emailRequired: "Email is required",
  emailInvalid: "Enter a valid email address",
  caste: "Caste",
  castePlaceholder: "E.g. Caste",
  casteRequired: "Caste is required",
  nationality: "Nationality",
  nationalityPlaceholder: "E.g. Indian",
  nationalityRequired: "Nationality is required",
  religionRequired: "Religion is required",
  categoryRequired: "Category is required",
  lastStudiedMediumRequired: "Last Studied Medium is required",
  preferredMediumRequired: "Preferred Medium is required",

  // Residential Details Section
  residentialDetails: "Residential Details",
  areYouResidingWith: "Are you residing with parents or with a guardian?",
  livingWithRequired: "This field is required",
  parent: "Parent",
  guardian: "Guardian",
  annualIncome: "Annual Income",
  annualIncomePlaceholder: "e.g., 250000",
  onlyNumbersAllowed: "Only Numbers Allowed.",
  districtPlaceholder: "E.g. District",
  districtRequired: "District is required",
  parentNameRequired: "Name is required",
  guardianNameRequired: "Name is required",
  occupationRequired: "Occupation is required",

  // Last Studied Details Section
  lastStudiedDetails: "Last Studied Details",
  lastStudiedClass: "Last Studied Class",
  lastStudiedSchool: "Last Studied School",
  lastStudiedMedium: "Last Studied Medium",
  emisNo: "EMIS No",
  emisNoPlaceholder: "E.g. 1212121212",
  emisNoInvalid: "Enter a valid EMIS No",
  eligibleForHigherStudies: "Eligible for Higher Studies",
  attachedDocumentType:
    "Attached Document (Transfer Certificate / Record Sheet)",
  document: "Document",
  documentRequired: "Document is required",
  allowedPdfJpgPng: "Allowed: PDF/JPG/PNG.",
  lastStudiedClassRequired: "Last Studied Class is required",
  lastStudiedSchoolRequired: "Last Studied School is required",

  // Preferred Course Details Section
  preferredCourseDetails: "Preferred Course Details",
  preferredClassForAdmission: "Preferred Class for Admission",
  selectPreferredClass: "Select Preferred Class",
  motherTongue: "Mother Tongue",
  selectMotherTongue: "Select Mother Tongue",
  preferredFirstLanguageToStudy: "Preferred First Language to Study",
  preferredMediumToStudy: "Preferred Medium to Study",
  smallpoxVaccinationTaken: "Smallpox Vaccination Taken?",
  preferredClassRequired: "Preferred Class for Admission is required",
  motherTongueRequired: "Mother Tongue is required",
  preferredFirstLanguageRequired:
    "Preferred First Language to Study is required",

  // Previous School Address Section
  previousSchoolAddress: "Previous School Address",
  schoolName: "School Name",
  classes: "Classes",
  yearOfStudy: "Year of Study",
  selectYear: "Select Year",
  mediumOfInstruction: "Medium of Instruction",
  schoolNameRequired: "School Name is required",
  yearOfStudyRequired: "Year of Study is required",

  // Identification Marks Section
  identificationMarksOnBody: "Identification Marks on the Body",
  identificationMark1: "Identification Mark 1",
  identificationMark2: "Identification Mark 2",
  identificationMark1Required: "Identification Mark 1 is required",
  identificationMark2Required: "Identification Mark 2 is required",

  // Other Details Section
  otherDetails: "Other Details",
  place: "Place",
  studentImage: "Student Image",
  placeRequired: "Place is required",
  studentImageRequired: "Student Image is required",
  allowedJpgPng: "Allowed: JPG/PNG images.",

  // Form Actions
  admissionApplicationForm: "Admission Application Form",
  verifyApplication: "Verify Application",
  applicationPreview: "Application Preview",
  confirmAndSubmit: "Confirm & Submit",

  // Affidavit
  parentGuardianAffidavit: "Parent / Guardian Affidavit",
  iAgreeToAboveStatements: "I have read and agree to the above statements.",

  // OTP
  enterOtpSentToEmail: "Enter the 6-digit OTP sent to your email",
  resendOtp: "Resend OTP",
  otpExpiresIn: "OTP expires in",
  otpRequired: "OTP is required",
  otpInvalid: "Enter a valid 6-digit OTP",

  // ---- Parent / Guardian Pledge (new for HSC) ----
  affidavitLine1:
    "I hereby undertake that my Son/Daughter shall strictly adhere to the rules and regulations of the school.",
  affidavitLine2:
    "In case of any misconduct, I agree to request and obtain the Transfer Certificate.",
  affidavitLine3:
    "I hereby certify that the above details are correct to the best of my knowledge.",
  affidavitLine4:
    'I further affirm that my son/daughter has not been enrolled in or studied at any school other than the one specified under "Previous School Address".',
  affidavitLine5:
    "I hereby declare that the date of birth and community details furnished in the admission application are true and correct.",
  affidavitLine6:
    "I further undertake that I will not apply for or request any change in these particulars at any time in the future.",

  // ==================== ADMISSION FORM XI to XII ====================
  // ---- Form Header ----
  formXItoXII: "Form - XI to XII",
  formItoX: "Form - I to X",

  reasonForWithdraw: "Reason For Withdraw",
  reasonForWithdrawRequired: "Reason for Withdraw is required",
  withdrawApplication: "Withdraw Application",

  feedback: "Feedback",
  feedbackRequired: "Feedback is required",

  // ---- Basic Details (new) ----
  birthPlace: "Birth Place",
  birthPlacePlaceholder: "E.g. Chennai",
  birthPlaceRequired: "Birth Place is required",
  communityCertificate: "Community Certificate",
  communityCertificateRequired: "Community Certificate is required",
  onlyTamilAllowed: "Please enter only Tamil characters",

  // ---- Academic Details (new section) ----
  academicDetails: "Academic Details",
  qualifyingExaminationPassed: "Qualifying Examination Passed",
  selectExamination: "Select Examination",
  nameOfExaminationBoard: "Name of the Examination Board",
  qualifyingExamRequired: "Qualifying Examination is required",
  examBoardRequired: "Examination Board is required",
  publicMarksNote:
    "The marks obtained in the qualifying examination must be duly attested either by the Headmaster of the school last studied or by a Gazetted Officer. The original mark certificate should NOT be sent along with the application. Only the attested copy of the mark statement should be enclosed with the application. The original mark statement must be produced at the time of admission.",

  // ---- Public Examination Marks (new section) ----
  publicExaminationMarks: "Public Examination Marks",
  nameOfExaminationPassed: "Name of the Examination Passed",
  monthAndYearOfExamination: "Month and Year of Examination",
  examinationRegisterNumber: "Examination Register Number",
  marksObtained: "Marks Obtained",
  maxMarks: "Max Marks",
  overall: "Overall",
  percentage: "Percentage",
  subject: "Subject",
  qualifiedExamRequired: "Name of Examination Passed is required",
  examMonthYearRequired: "Month and Year is required",
  registerNumberRequired: "Register Number is required",

  // ---- Preferred Course Details (new/updated keys) ----
  preferredStudyCourse: "Course Preferred to Study",
  selectCoursePrefered: "Select Course Preferred",
  yearOfAdmission: "Year of Admission (First Year / Second Year)",
  firstYear: "First",
  secondYear: "Second",
  preferredGroup1: "Preferred Group 1",
  preferredGroup2: "Preferred Group 2",
  preferredGroup3: "Preferred Group 3",
  selectPreferredGroup1: "Select Preferred Group 1",
  selectPreferredGroup2: "Select Preferred Group 2",
  selectPreferredGroup3: "Select Preferred Group 3",
  mediumOfInstructionLeavingSchool:
    "Medium of Instruction at the Time of Leaving School",
  preferredStudyCourseRequired: "Course Preferred to Study is required",
  yearOfAdmissionRequired: "Year of Admission is required",
  preferredGroup1Required: "Preferred Group 1 is required",
  mediumLeavingSchoolRequired: "Medium of Instruction is required",
  preferredCourseNote:
    "Please specify the order of preference for the stream you wish to study.",

  // ---- Last Studied Details (new/updated keys) ----
  studiedYear: "Year of Study",
  studiedYearRequired: "Year of Study is required",
  reasonForLeaving: "Reason for Leaving or Discontinuation",
  reasonForLeavingPlaceholder: "Enter reason for leaving or discontinuation",
  reasonForLeavingRequired: "Reason for leaving is required",
  lastStudiedSchoolNameRequired: "Name of Last Studied School is required",
  emisNoRequired: "EMIS No is required",

  // ---- Other Details (new keys) ----
  nccNssScoutsGuides:
    "NCC / NSS / Scouts / Guides / Red Cross – Would you like to join?",
  certificatesForCoCurricular: "Certificates for Co-curricular Activities",
  marksTable: "Marks Table",

  // ---- Residential (new) ----
  taluk: "Taluk",
  talukPlaceholder: "E.g. Taluk",
  talukRequired: "Taluk is required",

  // ---- Parent / Guardian Pledge (new for HSC) ----
  parentGuardianPledge: "Parent / Guardian Pledge",
  pledgeLine1:
    "I hereby declare that the particulars furnished above are true and correct to the best of my knowledge, and that I shall abide by the rules and regulations of the school.",
  pledgeLine2:
    "I am aware that if the admission is found to have been obtained based on false information or by suppressing facts, it is liable to be cancelled at any time.",
  pledgeLine3:
    "I further undertake to follow the school discipline, and in case of any violation, I agree to apply for and obtain the Transfer Certificate.",
  pledgeNote: "Note:",
  pledgeNote1:
    "Submit originals at the time of admission and keep photocopies.",
  pledgeNote2:
    "Certificates will not be returned once the student leaves school.",

  // ==================== ADMISSION List ====================
  secondaryVItoIX: "SECONDARY – VI TO IX",
  higherSecondaryXI: "HIGHER SECONDARY – XI",
  applicationId: "Application ID",
  appliedDate: "Applied Date",
  offlineApplication: "+ Offline Application",
  allocateSeat: "Allocate Seat",
  seatAllocated: "Seat Allocated",
  interviewSchedule: "Interview Schedule",
  checklist: "Checklist",
  moveToDropped: "Move to Dropped",
  bulkChangeStatus: "Bulk Change Status",
  proceed: "Proceed",
  approved: "Approved",
  rejectedSmall: "Rejected",
  alreadySeatAllocated: "Already Seat Allocated",
  // Modal header
  secondaryOnlineApplication: "Secondary Online Application",
  tamilKeyboard: "தமிழ் விசைப்பலகை",

  // Living with labels
  withParents: "With Parents",
  withGuardian: "With Guardian",

  // Document section
  documentToBeUploaded: "Document to be Uploaded",

  // Preferred course
  studentMotherTongue: "Student Mother Tongue",
  preferredMediumOfInstruction: "Preferred Medium of Instruction",

  // Status section
  statusDetails: "Status Details",
  currentStatus: "Current Status",
  status: "Status",
  selectStatus: "Select Status",
  proceed: "Proceed",
  reject: "Reject",
  hold: "Hold",

  // Buttons
  updateChanges: "Update Changes",

  // Messages
  updateSuccess: "Updated successfully!",
  updateFailed: "Failed to update. Please try again.",

  assignedGroup: "Assigned Group",
  preferredGroup: "Preferred Group",
  higherSecondaryOnlineApplication: "Higher Secondary Online Application",

  higherSecondaryApplication: "Higher Secondary Application",
  instructions: "Instructions",
  group: "Group",
  changeSectionOptional: "Change Section (Optional)",
  assignedClass: "Assigned Class",
  assignedSection: "Assigned Section",
  groupPlaceholder: "E.g. Group A",
  deletegroup: "Delete Group",
  // Bulk Status Change Modal
  approveApplication: "Approve Application",
  rejectStudents: "Reject Students",
  feedbackRemarks: "Feedback / Remarks",
  feedbackRemarksPlaceholder: "Enter feedback / remarks",
  feedbackRequired: "Feedback / Remarks is required",
  feedbackRecordedFor: "This feedback will be recorded for {count} student(s).",
  noStudentsSelected: "No students selected",
  bulkStatusChangeSuccess: "Status updated successfully!",
  bulkStatusChangeFailed: "Failed to update status. Please try again.",

  // Checklist Popup
  checkList: "Check List",
  checklistItems: "Checklist Items",
  checklistUpdateSuccess: "Checklist updated successfully",
  checklistUpdateFailed: "Checklist update failed",
  somethingWentWrongTryAgain: "Something went wrong. Please try again.",

  // Admission Status Actions (used in SecondaryAdmissionList & HigherSecondaryAdmissionList)
  areYouSure: "Are you sure?",
  confirmStatusChange: "Are you sure? Change status from '{from}' to '{to}'?",
  statusChangedSuccess: "Status changed successfully!",
  seatAllocateConfirm:
    "You can seat allocate only once at a time. Do you want to continue?",
  seatAllocatedSuccess: "Seat allocated successfully",
  somethingWentWrong: "Something went wrong",

  moveToDroppedConfirm: "Are you sure you want to move to dropped?",
  shiftName: "Shift Name",
  shiftNamePlaceholder: "Enter shift name (e.g., Morning Shift)",

  numberOfBreaks: "No. of Breaks",
  numberOfBreaksPlaceholder: "Enter number of breaks (0-10)",

  numberOfPeriods: "No. of Periods",
  numberOfPeriodsPlaceholder: "Enter number of periods (1-20)",

  breakDetails: "Break Details",
  periodDetails: "Period Details",

  breakType: "Break Type",
  breakTypePlaceholder: "Enter break type (e.g., Lunch, Coffee)",

  periodName: "Period Name",
  periodNamePlaceholder: "Enter period name (e.g., Work Session, Meeting)",

  createShift: "Create Shift",
  editShift: "Edit Shift",
  shiftNameRequired: "Shift Name is required",
  // fromTimeRequired: "From Time is required",
  // toTimeRequired: "To Time is required",
  shiftTimeInvalid: "Shift end time must be after start time",

  periodsRequired: "Number of Periods is required",
  periodsMin: "Number of Periods must be greater than 0",
  periodsMax: "Number of Periods cannot exceed 20",

  breaksRequired: "Number of Breaks is required",
  breaksMin: "Number of Breaks cannot be negative",
  breaksMax: "Number of Breaks cannot exceed 10",

  break: "Break",
  // period: "Period",

  typeRequired: "type is required",
  // nameRequired: "name is required",
  startTimeRequired: "start time is required",
  endTimeRequired: "end time is required",

  endAfterStart: "end time must be after start time",
  withinShift: "must be within shift hours",
  overlapWith: "overlaps with",
  deleteShift: "Delete Shift",

  // BOOK MODULE
  book: "Book",
  bookList: "Book List",
  viewBook: "View Book",
  term: "Term",
  volume: "Volume",
  totalPages: "Total Pages",
  subjectMedium: "Subject Medium",
  tableOfContents: "Table of Contents",
  topic: "Topic",
  subTopic: "Sub Topic",
  start: "Start",
  end: "End",
  bookPages: "Book Pages",
  pdfPages: "PDF Pages",
  selectTopicToView: "Select a topic to view",
  fullPdf: "FULL PDF",
  clickEyeIconToView: "Click the",
  eyeIcon: "eye icon",
  onAnyTopicToViewPages: "on any topic to view its pages here",
  failedToLoadPdf: "Failed to load PDF",
  prev: "Prev",
  next: "Next",
  page: "Page",
  of: "of",

  // BOOK CREATE MODULE
  bookDetails: "Book Details",
  addBook: "Add Book",
  editBook: "Edit Book",
  generateTableOfContents: "Generate Table of Contents",
  generatedTableOfContents: "Generated Table of Contents",
  selectMedium: "Select Medium",
  selectTerm: "Select Term",
  selectVolume: "Select Volume",
  contentStartPage: "Content Start Page",
  contentEndPage: "Content End Page",
  enterContentStartPage: "Enter Content Start Page",
  enterContentEndPage: "Enter Content End Page",
  bookFirstPageNo: "Book First Page No.",
  pdfPageOfBookFirstPageNo: "PDF Page of Book First Page No.",
  enterBookPDFNumber: "Enter Book PDF Number",
  uploadBookPdf: "Upload Book (PDF)",
  printedPageOnFirstContentPage: "Printed page number on first content page",
  openPdfInViewer:
    "Open PDF in viewer, find the page showing above number, enter that PDF page number",
  subjectMediumRequired: "Subject Medium is required",
  onlyPdfFilesAllowed: "Only PDF files are allowed",
  fileNameMismatch: "File name does not match the selected",
  expectedFileName: "Expected file name format",
  viewUploadedBook: "VIEW UPLOADED BOOK",
  backToAddBook: "BACK TO ADD BOOK",
  contentsPage: "Contents Page",
  selectClassFirst: "Select Class First",
  close: "Close",

  // MANDATORY PAGE FIELD VALIDATIONS
  contentStartPageRequired: "Content Start Page is required",
  contentEndPageRequired: "Content End Page is required",
  bookFirstPageNoRequired: "Book First Page No. is required",
  pdfPageOfBookFirstPageNoRequired:
    "PDF Page of Book First Page No. is required",
  contentEndPageMustBeAfterStart:
    "Content End Page must be greater than or equal to Content Start Page",
  bookFirstPageNoMin: "Book First Page No. must be at least 1",
  pdfPageNoMin: "PDF Page of Book First Page No. must be at least 1",

  // LESSON PLAN LIST
  // Tab labels (new)
  tabAll: "All",
  tabSubmitted: "Submitted",
  tabApproved: "Approved",
  tabRejected: "Rejected",

  tabClasswise: "Class-wise",
  tabTeacherwise: "Teacher-wise",

  // Toggle labels (new)
  toggleAll: "All",
  toggleThisWeek: "This week",

  // Table headers (mostly reused; new ones below)
  scheduledDate: "Scheduled Date",
  startDatePlaceholder: "Start Date",
  endDatePlaceholder: "End Date",

  // Accordion / transaction history (new)
  userName: "User Name",
  updatedStatus: "Updated Status",
  updatedOn: "Updated On",
  comments: "Comments",
  noHistoryFound: "No history found",

  // Statuses (only new ones; "submitted", "approved", "rejected" already exist)
  resubmitted: "Resubmitted",
  completed: "Completed",

  // Buttons (reused "add", "delete"; new below)
  calendar: "Calendar",
  notifications: "Notifications",

  // Lesson Plan View
  viewLessonPlan: "View Lesson Plan",
  studyMaterial: "Study Material",
  savedLessonPlan: "Saved Lesson Plan",
  lessonPlan: "Lesson Plan",
  schedule: "Schedule",
  draft: "Draft",
  noSavedLessonPlans: "No saved lesson plans found",
  failedToLoadLessonPlan: "Failed to load lesson plan",

  // LESSON PLAN CREATE
  createLessonPlan: "Create Lesson Plan",
  editLessonPlan: "Edit Lesson Plan",
  breadcrumbSeparator: "/",
  selectBook: "Select Book",
  selectTopicPlaceholder: "Select Topic",
  selectSection: "Select Section",
  selectSubTopic: "Select Sub Topic",
  minPageShort: "Min",
  maxPageShort: "Max",
  breadcrumbAriaLabel: "Breadcrumb",
  startPageLabel: "Start Page",
  endPageLabel: "End Page",
  enterStartPage: "Enter Start Page",
  enterEndPage: "Enter End Page",
  scheduleDate: "Schedule Date",
  selectDate: "Select Date",
  weeklyScheduleTitle: "Weekly Schedule",
  scheduleGridEmpty: "Select a schedule date to view the timetable",
  periodRoman: "Period",
  legendSubmitted: "Submitted",
  legendApproved: "Approved",
  legendRejected: "Rejected",
  legendResubmitted: "Re-Submitted",
  cellEmpty: "---",
  generatingLessonPlan: "Generating...",
  generateLessonPlan: "Generate Lesson Plan",
  regenerateLessonPlan: "Re-Generate",
  lessonPlanEditorTitle: "Lesson Plan Editor",
  bookPdfTitle: "Book PDF",
  pdfFallbackMessage: "PDF will appear here",
  lessonPlanEditorPlaceholder: "Generated lesson plan will appear here...",
  modalSuccessTitle: "Success",
  modalFailedTitle: "Failed",
  lessonPlanUpdatedSuccess: "Lesson plan updated successfully!",
  lessonPlanCreatedSuccess: "Lesson plan created successfully!",
  failedToSaveLessonPlan: "Failed to save lesson plan.",
  failedToGenerateLessonPlan: "Failed to generate lesson plan.",
  somethingWentWrongGenerate:
    "Something went wrong while generating the lesson plan.",
  somethingWentWrongSave: "Something went wrong while saving the lesson plan.",
  bookRequired: "Book is required",
  topicRequired: "Topic is required",
  startPageRequired: "Start page is required",
  endPageRequired: "End page is required",
  scheduleDateRequired: "Schedule date is required",
  pageBetween: "Must be between",
  pageValueBetween: "Value must be between",
  andLabel: "and",
  endPageAfterStart: "End page must be greater than or equal to start page",
  socialScienceSample: "Social Science",
  classSectionSample: "VI - A",
  lessonPeriodSlot1: "09:30 am - 10:15 am",
  lessonPeriodSlot2: "10:15 am - 11:00 am",
  lessonPeriodSlot3: "11:15 am - 12:00 pm",
  lessonPeriodSlot4: "12:00 pm - 12:45 pm",
  lessonPeriodSlot5: "01:30 pm - 02:15 pm",
  lessonPeriodSlot6: "02:15 pm - 03:00 pm",
  lessonPeriodSlot7: "03:15 pm - 04:00 pm",
  lessonPeriodSlot8: "04:00 pm - 04:45 pm",
  legendCompleted: "Completed",
  loadingTimetable: "Loading timetable...",
  noTimetableFound: "No timetable found for this week.",
  saveAsDraft: "Save as Draft",
  submitToHM: "Submit to HM",
  scheduleLessonPlan: "Schedule Lesson Plan",
  lessonPlanScheduledSuccess: "Lesson plan scheduled successfully",
  failedToScheduleLessonPlan: "Failed to schedule lesson plan",
  invalidSubjectSelection: "You can only select periods with the same subject",
  invalidClassSelection: "You can only select periods with the same class",
  selectAtLeastOneCell: "Please select at least one period to schedule",
  weeklyTimetable: "Weekly Timetable",
  invalidCellStatusSelection:
    "You cannot schedule a period that is already submitted, approved, rejected, re-submitted, or completed.",
  selectTimetableCellFirst:
    "Please select a timetable cell first before choosing a lesson plan.",
  selectLessonPlanFirst: "Please select a lesson plan before submitting.",
  statusApproved: "Approved",
  statusCompleted: "Completed",
  selectRowToDelete: "Please select a row to delete",
  deleteSuccess: "Deleted successfully",
  deleteFailed: "Delete failed",
  statusUpdateSuccess: "Status updated successfully",
  statusUpdateFailed: "Status update failed",
  failedToFetchLessonPlan: "Failed to fetch lesson plan",
  lessonPlanScheduledSuccess: "Lesson plan scheduled successfully",
  failedToScheduleLessonPlan: "Failed to schedule lesson plan",

  // AI ASSESSMENT
  assessment: "Assessment",
  remedialAssessment: "Remedial Assessment",
  pass: "Pass",
  fail: "Fail",
  title: "Title",
  questionsCount: "Questions Count",
  questionCount: "Questions Count",
  createdDate: "Created Date",
  viewAssessment: "View Assessment",
  viewRemedialAssessment: "View Remedial Assessment",
  viewStudyMaterial: "View Study Material",

  // Generate Assessment section
  generateAssessment: "Generate Assessment",
  difficultyLevel: "Difficulty Level",
  selectDifficulty: "Select Difficulty",
  mcqOptionsCount: "MCQ Options Count",
  enterOptionsCount: "Enter Options Count",
  passPercentage: "Pass Percentage",
  selectPassPercentage: "Select",
  enterNumberOfQuestions: "Enter Number of Questions",

  // Generate / Re-generate buttons
  generating: "Generating...",
  generate: "Generate",
  regenerate: "Re-Generate",

  // Preview Assessment panel
  previewAssessment: "Preview Assessment",
  explanation: "Explanation",
  noQuestionsGenerated: "No questions generated yet",

  // Helper placeholders
  selectBookFirst: "Select Book First",
  selectTopicFirst: "Select Topic First",

  // Validation messages
  numQuestionsRequired: "Number of Questions is required",
  maxQuestionsAllowed: "Maximum 10 questions allowed",
  minQuestionRequired: "Minimum 1 question required",
  difficultyLevelRequired: "Difficulty Level is required",
  mcqOptionsRequired: "MCQ Options Count is required",
  passPercentageRequired: "Pass Percentage is required",
  subTopicRequired: "Sub Topic is required",
  endPageGreaterStart: "End Page must be >= Start Page",
  startPageMin: "Start Page must be >=",
  endPageMax: "End Page must be <=",

  // API success / failure messages
  assessmentGeneratedSuccess: "Assessment generated successfully",
  failedToGenerateAssessment: "Failed to generate assessment",
  assessmentSavedSuccess: "Assessment saved successfully",
  failedToSaveAssessment: "Failed to save assessment",

  // AI ASSESSMENT VIEW
  studentsList: "Students List",
  submittedDate: "Submitted Date",
  viewResult: "View Result",
  createRemedialAssessment: "Create Remedial Assessment",
  createStudyMaterial: "Create Study Material",
  failedToFetchAssessment: "Failed to fetch assessment details",
  numberOfQuestion: "Number of Question",
};

export default en;
